const is = {
   not: {
      empty: 1,
      negative: 0,
   },
   positive: 1,
   to: {
      be: {
         validated: true,
      },
   },
};

export default is;